import { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import logo from "../assets/logo-icon.svg";
import pagesIcon from "../assets/pages.svg";
import navIcon from "../assets/nav.svg";
import contactIcon from "../assets/contact.svg";
import blogsIcon from "../assets/blogs.svg";
import fileIcon from "../assets/file-icon.svg";
import libraryIcon from "../assets/media.svg";
import settingIcon from "../assets/setting.svg";
import dropdownIcon from "../assets/dropdown-icon.svg";
import sectionIcon from "../assets/section.svg";
import organizationIcon from "../assets/organization.svg";
import projectsIcon from "../assets/projects.svg";
import jobIcon from "../assets/job.svg";
import logoutIcon from "../assets/logout.svg";
import { useAuth } from "../context/AuthContext";
import { fetchProjectList } from "../action/Projectsaction";
import { updateToken } from "../action/user";
import { toast } from "react-toastify";
import { Form } from "react-bootstrap";
import sideMenuConfig from "../utils/dynamic_sidemenu";

export default function Sidebar({ isOpen = false, onClose = () => { } }) {
  const { logout, user } = useAuth();
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState();
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const navigate = useNavigate();
  const [menuItems, setMenuItems] = useState([]);

  // const menuItems = [
  //   { label: "Organization", path: "/organization", icon: organizationIcon },
  //   { label: "Projects", path: "/projects", icon: projectsIcon },
  //   { label: "Pages", path: "/pages", icon: pagesIcon },
  //   { label: "Navigation", path: "/navigation", icon: navIcon },
  //   { label: "Forms", path: "/all-forms", icon: contactIcon },
  //   { label: "Blogs", path: "/blogs", icon: blogsIcon },
  //   { label: "Case Studies", path: "/case-studies", icon: fileIcon },
  //   // { label: "Job Listing", path: "/job-listing", icon: jobIcon },
  //   {
  //     label: "Media Library",
  //     path: "/media-library",
  //     icon: libraryIcon,
  //     // children: [
  //     //   { label: "Media Library", path: "/media-library" },
  //     //   { label: "Drafts", path: "/media-library/drafts" },
  //     // ],
  //   },
  //   { label: "Section Masters", path: "/section", icon: sectionIcon },
  //   { label: "Settings", path: "/settings", icon: settingIcon },

  // ];

  const [openMenus, setOpenMenus] = useState({});

  const toggleMenu = (label) => {
    setOpenMenus((prev) => ({ ...prev, [label]: !prev[label] }));
  };

  // helper to close on mobile only
  const handleNavClick = () => {
    // only close if currently open (so desktop behavior unchanged)
    if (isOpen && typeof onClose === "function") onClose();
  };
  useEffect(() => {
    const loadProjects = async () => {
      const res = await fetchProjectList(1, 50, "");
      if (res?.status === 1) {
        setProjects(res.data.list);
      
        // set default first run
        if (!localStorage.getItem("activeProjectId")) {
          const defaultProj =
            res.data.list.find((p) => p.name.toLowerCase().includes("evaleo")) ||
            res.data.list[0];
          if (defaultProj) {
            localStorage.setItem("activeProjectId", defaultProj._id);
            localStorage.setItem("activeProjectName", defaultProj.name);
            localStorage.setItem("activeProjectApi", defaultProj.domains[0]);
            localStorage.setItem("shortcode", defaultProj.shortcode);
            setSelectedProject(defaultProj._id);
          }
        }
      } else {
        localStorage.removeItem("token");
        window.location.href = "/login";
        return;
      }
    };

    loadProjects();
  }, []);
  const handleProjectSelect = async () => {
    const proj = projects.find((p) => p._id === selectedProject);
    localStorage.setItem("shortcode", proj?.shortcode);
    setShowDeletePopup(false);
    const res = await updateToken({ project_id: selectedProject });
    if (res?.status) {
      localStorage.setItem("token", res.data);
    } else {
      toast.error(res?.message || "Update token failed");
    }

    if (isOpen && typeof onClose === "function") onClose();
    navigate("/pages");
    window.location.reload(); 
  };

  useEffect(() => {
    const shortcode = localStorage.getItem("shortcode"); // "tec" | "the" | "eva"
  
    // fallback key
    const DEFAULT_MENU = "default";
    const selectedMenu =
      shortcode && sideMenuConfig[shortcode]
        ? sideMenuConfig[shortcode]
        : sideMenuConfig[DEFAULT_MENU];
    setMenuItems(selectedMenu);
  }, []);

  return (
    <aside className={`sidebar ${isOpen ? "show" : ""}`}>
      <div className="sidebar-header">
        <div className="logo">
          <img src={logo} alt="Evaleo" className="logo-icon" />
        </div>
        {/* optional close button visible only on mobile */}
        <button className="btn close-sidebar d-mobile-only ms-auto" onClick={onClose}>
          ✕
        </button>
      </div>
      <div className="sidebar-projects">
        <Form.Select
          className="frm-input"
          value={user.project_id}
          onChange={(e) => {
            setShowDeletePopup(true);
            setSelectedProject(e.target.value);
          }}
        >
          {projects.map((p) => (
            <option key={p._id} value={p._id}>
              {p.name}
            </option>
          ))}
        </Form.Select>
      </div>

      <nav className="sidebar-nav">
        {menuItems.map((item, idx) => (
          <div key={idx} className="menu-item">
            {item.children ? (
              <>
                <button
                  className={`sidebar-link has-children ${openMenus[item.label] ? "submenu-open" : ""
                    }`}
                  onClick={() => toggleMenu(item.label)}
                >
                  <span className="navicon">
                    <img src={item.icon} alt={`${item.label} icon`} />
                  </span>
                  {item.label}
                  <span className="arrow">
                    <img
                      src={dropdownIcon}
                      className={openMenus[item.label] ? "rotated" : ""}
                      alt="dropdown arrow"
                    />
                  </span>
                </button>

                {openMenus[item.label] && (
                  <div className="submenu">
                    {item.children.map((sub, subIndex) => (
                      <NavLink
                        key={subIndex}
                        to={sub.path}
                        className={({ isActive }) =>
                          `submenu-link ${isActive ? "active" : ""}`
                        }
                        onClick={handleNavClick}
                      >
                        {sub.label}
                      </NavLink>
                    ))}
                  </div>
                )}
              </>
            ) : (
              <NavLink
                to={item.path}
                className={({ isActive }) =>
                  `sidebar-link ${isActive ? "active" : ""}`
                }
                onClick={handleNavClick}
                end
              >
                <span className="navicon">
                  <img src={item.icon} alt={`${item.label} icon`} />
                </span>
                {item.label}
              </NavLink>
            )}
          </div>
        ))}
      </nav>
      <div className="sidebar-footer">
        <div className="logout-nav">
          <div className="userdtl">
            <div className="usertitle">{user?.name || ""}</div>
            <div className="useremail">{user?.email || ""}</div>
          </div>
          <button onClick={logout}><img src={logoutIcon} alt="Logout" /></button>
        </div>
      </div>

      {showDeletePopup && (
        <div className="popup-overlay">
          <div className="popup-container">
            <h4 className="popup-title">Switch Project?</h4>
            <p className="popup-message">
              Are you sure you want to switch the project?
            </p>

            <div className="popup-actions">
              <button
                className="btn-white"
                onClick={() => setShowDeletePopup(false)}
              >
                No
              </button>

              <button
                className="btn-black"
                onClick={handleProjectSelect}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
    </aside>
  );
}
